export { SDK_SERVICE_KEY } from '@or-sdk/sdk-api';
export const ROLES = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    USER: 'USER',
    GUEST: 'GUEST',
    UNAUTHORIZED: 'UNAUTHORIZED',
};
//# sourceMappingURL=constants.js.map